import { useLabel } from '@platform/hooks/useLabel';
import { crumbsOf, placement, type ICrumb } from '@platform/navigation';
import { useGetCatalogQuery, useMeQuery } from '@platform/state/api';

/**
 * Крихти сторінки нового запису «Простір › Група › Модуль (› Таблиця) › {label}» (layout/breadcrumbs) — без запиту запису за маршрутом:
 * нового запису на сервері ще немає.
 */
export function useNewRecordCrumbs(ws: string, moduleKey: string, rtKey: string, label: string): ICrumb[] {
  const lbl = useLabel();
  const { data: me } = useMeQuery();
  const { data: catalog } = useGetCatalogQuery({ workspaceId: ws }, { skip: !ws });
  const summary = catalog?.modules.find((m) => m.key === moduleKey);
  const main = summary?.recordTypes.find((r) => r.main)?.key;
  const child = rtKey !== main ? summary?.recordTypes.find((r) => r.key === rtKey) : undefined;
  return crumbsOf({
    workspaceName: me?.workspaces.find((w) => w.id === ws)?.name ?? '', label: lbl, placement: placement(moduleKey),
    module: { key: moduleKey, label: summary ? lbl(summary.name) : moduleKey }, table: child ? { key: child.key, label: lbl(child.name) } : null, record: label,
  });
}
